export const QA_NAME_GRETA_AI_CHAT_HISTORY_RETRY = 'gretaAIChatHistoryRetry'
